"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getImageMimeType = function (extension) {
    switch (extension) {
        case 'png':
            return 'image/png';
        case 'webp':
            return 'image/webp';
        case 'jpeg':
            return 'image/jpeg';
        default:
            throw new Error(extension + " MIME type is unknown");
    }
};
exports.default = getImageMimeType;
//# sourceMappingURL=getImageMimeType.js.map